import axios from '@/plugins/axios.js';


export function getCity() {
  return axios.get('/city')
    .then(res => {
      if (res.status === 200) return res.data;
      return null;
    })
    .catch(error => {
      console.error(error);
      return null;
    });
}

export function getCountry(city) {
  return axios.get(`/country?city=${city}`).then(res => {
      if (res.status === 200) return res.data;
      return null;
    })
    .catch(error => {
      console.error(error);
      return null;
    });
}
